import {Component, Injectable, OnInit} from '@angular/core';
import {PublicSubmitForm} from '../../sdk/interface/form/public-submit-form';
import {Router} from '@angular/router';
import {UntypedFormBuilder, Validators} from '@angular/forms';
import {AlertService} from '../../sdk/service/alert.service';
import {ROUTES} from '../../app.routes';
import {PublicService, UserRecovery} from 'web-angular-client';
import {AuthenticationService} from '../../sdk/service/authentication.service';
import {EnvironmentService} from '../../sdk/service/environment.service';
import {NgxUiLoaderService} from 'ngx-ui-loader';
import {finalize} from 'rxjs';

@Component({
    selector: 'app-account-recovery',
    templateUrl: './account-recovery.component.html',
    styleUrls: ['./account-recovery.component.scss'],
    standalone: false
})
@Injectable({
    providedIn: 'root'
})
export class AccountRecoveryComponent extends PublicSubmitForm implements OnInit
{

    constructor(
        protected router: Router,
        protected formBuilder: UntypedFormBuilder,
        protected alertService: AlertService,
        protected authenticationService: AuthenticationService,
        protected publicService: PublicService,
        private ngxLoader: NgxUiLoaderService,
        protected environmentService: EnvironmentService,
    )
    {
        super(router, formBuilder, alertService, authenticationService, environmentService);
    }

    ngOnInit()
    {
        this.form = this.formBuilder.group({
            email: ['', [Validators.required, Validators.email]]
        });
    }

    /**
     * Submits a password reset request for the entered email address.
     * Always displays a generic success message regardless of whether the email exists.
     */
    submit(action): void
    {

        let userRecovery: UserRecovery = {};
        userRecovery.username = this.f.email.value;

        this.ngxLoader.start();
        this.publicService.sendAccountRecoveryNotification(userRecovery)
            .pipe(finalize(() => this.ngxLoader.stop()))
            .subscribe({
                    next: () =>
                    {
                        this.notifyAndNavigateToLogin();
                    }, error: e =>
                    {
                        this.notifyAndNavigateToLogin();
                        this.debugOutput('account recovery notification failed with: ', e);
                    }
                }
            );
    }

    notifyAndNavigateToLogin(): void
    {
        this.alertService.success('A password reset link has been sent.', true);
        this.router.navigate([ROUTES.PUBLIC.LOGIN.path]).then();
    }
}